// extracted by mini-css-extract-plugin
export var contactIconsWrapper = "layout-module--contactIconsWrapper--1am_8";
export var contactIcons = "layout-module--contactIcons--ZM9hl";
export var longLine = "layout-module--longLine--289Ee";
export var shortLine = "layout-module--shortLine--c9IXO";
export var light = "layout-module--light--2oB96";
export var main = "layout-module--main--1mXJb";